(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7859,40659,81066,75847,44709,40852,81243,74453,44954,40617],{

/***/ 90704:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Cards_Card; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_extends.mjs
function extends_() {
  extends_ = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return extends_.apply(this, arguments);
}

function _extends() {
  return extends_.apply(this, arguments);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./components/BlogCommon/Article/ContentfulParser/index.jsx
var ContentfulParser = __webpack_require__(92870);
// EXTERNAL MODULE: ./UI/components/Illustration/index.jsx + 1 modules
var Illustration = __webpack_require__(93812);
// EXTERNAL MODULE: ./UI/components/Typography/index.jsx
var Typography = __webpack_require__(59654);
// EXTERNAL MODULE: ./UI/components/Typography/utils/useTypography.js
var useTypography = __webpack_require__(18422);
// EXTERNAL MODULE: ./UI/containers/CardContainer/index.jsx + 1 modules
var CardContainer = __webpack_require__(35565);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./UI/components/LinkWrapper/index.jsx + 2 modules
var LinkWrapper = __webpack_require__(56362);
// EXTERNAL MODULE: ./UI/containers/Overlay/index.jsx + 1 modules
var Overlay = __webpack_require__(81101);
// EXTERNAL MODULE: ./UI/components/Cards/OverlapCard/OverlapCard.module.scss
var OverlapCard_module = __webpack_require__(42070);
var OverlapCard_module_default = /*#__PURE__*/__webpack_require__.n(OverlapCard_module);
;// CONCATENATED MODULE: ./UI/components/Cards/OverlapCard/index.jsx











var hasTextContent = function(text) {
    var ref;
    if (!text) {
        return false;
    }
    if (typeof text === "string") {
        return Boolean(text.trim());
    }
    return Boolean(text === null || text === void 0 ? void 0 : (ref = text.content) === null || ref === void 0 ? void 0 : ref.length);
};
var OverlapCard = function(param) {
    var className = param.className, image = param.image, title = param.title, text = param.text, description = param.description, url = param.url;
    if (!(image === null || image === void 0 ? void 0 : image.url)) {
        return null;
    }
    var hasHoverContent = Boolean(title || description || hasTextContent(text));
    var Wrapper = url ? LinkWrapper/* default */.Z : "div";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, url && {
        path: url
    }), {
        className: classnames_default()((OverlapCard_module_default()).overlapCard, className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Illustration["default"], {
                className: (OverlapCard_module_default()).image,
                src: image.url,
                alt: image.alt || title || "",
                transparent: true
            }),
            hasHoverContent && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Overlay/* default */.Z, {
                className: (OverlapCard_module_default()).overlay,
                children: [
                    title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography["default"], {
                        variant: useTypography/* TYPOGRAPHY_TAGS.h3 */.w1.h3,
                        size: useTypography/* TYPOGRAPHY_SIZE.headline20 */.y3.headline20,
                        isBold: true,
                        children: title
                    }),
                    (hasTextContent(text) || description) && (text ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentfulParser["default"], {
                        document: text
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: description
                    }))
                ]
            }),
            url && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (OverlapCard_module_default()).badge,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                    width: 16,
                    height: 16,
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    strokeWidth: 2.5,
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M7 17 17 7M9 7h8v8"
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ var Cards_OverlapCard = (OverlapCard);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./UI/components/Cards/Card/Card.module.scss
var Card_module = __webpack_require__(93856);
var Card_module_default = /*#__PURE__*/__webpack_require__.n(Card_module);
;// CONCATENATED MODULE: ./UI/components/Cards/Card/utils/useCard.jsx








/* harmony default export */ function useCard(_param) {
    var url = _param.url, classes = _param.className, withoutBackground = _param.withoutBackground, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "url",
        "className",
        "withoutBackground"
    ]);
    var Wrapper = url ? function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper/* default */.Z, (0,_object_spread/* default */.Z)({}, props));
    } : function(_param) /*#__PURE__*/ {
        var path = _param.path, className = _param.className, imagesBundles = _param.imagesBundles, restWrapper = (0,_object_without_properties/* default */.Z)(_param, [
            "path",
            "className",
            "imagesBundles"
        ]);
        return (0,jsx_runtime.jsx)(react.Fragment, (0,_object_spread/* default */.Z)({}, restWrapper));
    };
    var _obj;
    var className = classnames_default()((Card_module_default()).card, classes, (_obj = {}, (0,_define_property/* default */.Z)(_obj, (Card_module_default()).withoutBackground, withoutBackground), (0,_define_property/* default */.Z)(_obj, (Card_module_default()).withLink, url), _obj));
    return (0,_object_spread/* default */.Z)({
        Wrapper: Wrapper,
        className: className,
        withoutBackground: withoutBackground,
        path: url
    }, rest);
};

;// CONCATENATED MODULE: ./UI/components/Cards/Card/index.jsx
















var Svg = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6778).then(__webpack_require__.bind(__webpack_require__, 6778));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6778)
            ];
        }
    },
    ssr: false
});
var getNestedCardProps = function(module) {
    if (module === null || module === void 0 ? void 0 : module.fields) {
        var ref = (0,helper/* getDocumentFields */.OA)(module, [
            "title",
            "text",
            "description",
            "images",
            "contentList",
            "contentModules",
            "subtitle", 
        ]), title = ref.title, text = ref.text, description = ref.description, images = ref.images, contentList = ref.contentList, contentModules = ref.contentModules, subtitle = ref.subtitle;
        return {
            title: title,
            text: text,
            description: description,
            image: (0,helper/* getImage */.gJ)(get_default()(images, "[0]")),
            icon: get_default()(contentList, "[0]"),
            contentModules: contentModules,
            subtitle: subtitle
        };
    }
    return (0,_object_spread/* default */.Z)({}, module);
};
var Card = function(props) {
    var _ref = useCard(props), Wrapper = _ref.Wrapper, icon = _ref.icon, title = _ref.title, text = _ref.text, children = _ref.children, className = _ref.className, image = _ref.image, withoutBackground = _ref.withoutBackground, items = _ref.items, svgWithWrapper = _ref.svgWithWrapper, contentModules = _ref.contentModules, specificCardOverlay = _ref.specificCardOverlay, rest = (0,_object_without_properties/* default */.Z)(_ref, [
        "Wrapper",
        "icon",
        "title",
        "text",
        "children",
        "className",
        "image",
        "withoutBackground",
        "items",
        "svgWithWrapper",
        "contentModules",
        "specificCardOverlay"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContainer/* default */.Z, {
            className: className,
            noBackground: withoutBackground,
            children: [
                !!(image === null || image === void 0 ? void 0 : image.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Illustration["default"], {
                    className: (Card_module_default()).image,
                    src: image.url,
                    alt: image.alt,
                    transparent: true
                }),
                icon && (svgWithWrapper ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Card_module_default()).iconWrapper,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg, {
                        type: icon,
                        className: (Card_module_default()).icon
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg, {
                    type: icon,
                    className: (Card_module_default()).icon
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Card_module_default()).content,
                    children: [
                        title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography["default"], {
                            variant: useTypography/* TYPOGRAPHY_TAGS.h3 */.w1.h3,
                            size: useTypography/* TYPOGRAPHY_SIZE.headline20 */.y3.headline20,
                            isBold: true,
                            className: (Card_module_default()).title,
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Card_module_default()).cardContent,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentfulParser["default"], {
                                    document: text
                                }),
                                !!(items === null || items === void 0 ? void 0 : items.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Card_module_default()).itemList,
                                    children: items.map(function(item) {
                                        var ref;
                                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                            className: (Card_module_default()).item,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg, {
                                                    type: (ref = item.contentList) === null || ref === void 0 ? void 0 : ref[0],
                                                    className: (Card_module_default()).itemIcon
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: item.title
                                                })
                                            ]
                                        }, item.title);
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            "data-read-more": true,
                            className: (Card_module_default()).readMore,
                            children: "Read more"
                        })
                    ]
                }),
                !!(contentModules === null || contentModules === void 0 ? void 0 : contentModules.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Card_module_default()).contentModules,
                    children: contentModules.map(function(module, index) {
                        var cardProps = _extends({}, getNestedCardProps(module));
                        var key = cardProps.title || index;
                        if (specificCardOverlay) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Cards_OverlapCard, {
                                className: (Card_module_default()).overlapCard,
                                image: cardProps.image,
                                title: cardProps.title,
                                text: cardProps.text,
                                description: cardProps.description,
                                url: cardProps.subtitle
                            }, key);
                        }
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card, (0,_object_spread/* default */.Z)({
                            className: (Card_module_default()).nestedCard
                        }, cardProps), key);
                    })
                }),
                children
            ]
        })
    }));
};
/* harmony default export */ var Cards_Card = (Card);


/***/ }),

/***/ 35565:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ containers_CardContainer; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./UI/containers/CardContainer/CardContainer.module.scss
var CardContainer_module = __webpack_require__(14910);
var CardContainer_module_default = /*#__PURE__*/__webpack_require__.n(CardContainer_module);
;// CONCATENATED MODULE: ./UI/containers/CardContainer/utils/useCardContainer.js





/* harmony default export */ function useCardContainer(_param) {
    var children = _param.children, classes = _param.className, noBackground = _param.noBackground, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "className",
        "noBackground"
    ]);
    var className = classnames_default()((CardContainer_module_default()).cardContainer, classes, (0,_define_property/* default */.Z)({}, (CardContainer_module_default()).noBackground, noBackground));
    return (0,_object_spread/* default */.Z)({
        children: children,
        className: className
    }, rest);
};

;// CONCATENATED MODULE: ./UI/containers/CardContainer/index.jsx







var CardContainer = function(props, ref) {
    var _ref = useCardContainer(props), children = _ref.children, className = _ref.className, restProps = (0,_object_without_properties/* default */.Z)(_ref, [
        "children",
        "className"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: className,
        ref: ref
    }, restProps), {
        children: children
    }));
};
CardContainer.propTypes = {
    children: (prop_types_default()).node.isRequired,
    noBackground: (prop_types_default()).bool,
    className: (prop_types_default()).string
};
/* harmony default export */ var containers_CardContainer = (/*#__PURE__*/(0,react.forwardRef)(CardContainer));


/***/ }),

/***/ 81101:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ containers_Overlay; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./UI/containers/Overlay/Overlay.module.scss
var Overlay_module = __webpack_require__(44291);
var Overlay_module_default = /*#__PURE__*/__webpack_require__.n(Overlay_module);
;// CONCATENATED MODULE: ./UI/containers/Overlay/utils/useOverlay.js




/* harmony default export */ function useOverlay(_param) {
    var classes = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    var className = classnames_default()((Overlay_module_default()).overlay, classes);
    return (0,_object_spread/* default */.Z)({
        className: className
    }, props);
};

;// CONCATENATED MODULE: ./UI/containers/Overlay/index.jsx






var Overlay = function(props) {
    var _ref = useOverlay(props), className = _ref.className, children = _ref.children, restProps = (0,_object_without_properties/* default */.Z)(_ref, [
        "className",
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: className
    }, restProps), {
        children: children
    }));
};
Overlay.propTypes = {
    children: (prop_types_default()).node.isRequired,
    className: (prop_types_default()).string
};
/* harmony default export */ var containers_Overlay = (Overlay);


/***/ }),

/***/ 20325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ sections_TwoBlockChallanges; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./UI/components/ChallengesAndSolutions/index.jsx + 5 modules
var ChallengesAndSolutions = __webpack_require__(59870);
// EXTERNAL MODULE: ./UI/components/Illustration/index.jsx + 1 modules
var Illustration = __webpack_require__(93812);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
;// CONCATENATED MODULE: ./UI/sections/TwoBlockChallanges/utils/useChallengesAndSolutionsWithWireframes.js

var useChallengesAndSolutionsWithWireframes = function(param) {
    var data = param.data, type = param.type;
    var ref, ref1;
    var view = data.view, contentModules = data.contentModules, rawImages = data.images, background = data.background;
    var images = (rawImages || []).map(function(rawImage) {
        return (0,helper/* getImage */.gJ)(rawImage);
    });
    var backgroundImageUrl = (0,helper/* getImage */.gJ)(background).url;
    return {
        data: data,
        type: type,
        view: view,
        firstBlock: contentModules === null || contentModules === void 0 ? void 0 : (ref = contentModules[0]) === null || ref === void 0 ? void 0 : ref.fields,
        secondBlock: contentModules === null || contentModules === void 0 ? void 0 : (ref1 = contentModules[1]) === null || ref1 === void 0 ? void 0 : ref1.fields,
        images: images,
        backgroundImageUrl: backgroundImageUrl
    };
};

// EXTERNAL MODULE: ./UI/sections/TwoBlockChallanges/styles.module.scss
var styles_module = __webpack_require__(89182);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(30719);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./UI/components/SectionTitle/index.jsx
var SectionTitle = __webpack_require__(15805);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__(2664);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 92 modules
var swiper_esm = __webpack_require__(44040);
// EXTERNAL MODULE: ./redux/selectors/layout.js
var layout = __webpack_require__(19341);
// EXTERNAL MODULE: ./UI/components/Cards/Card/index.jsx + 3 modules
var Card = __webpack_require__(90704);
// EXTERNAL MODULE: ./UI/containers/Overlay/index.jsx + 1 modules
var Overlay = __webpack_require__(81101);
// EXTERNAL MODULE: ./utils/routes.js
var routes = __webpack_require__(27727);
// EXTERNAL MODULE: ./UI/sections/CaseCardsSection/CardsSection.module.scss
var CardsSection_module = __webpack_require__(94211);
var CardsSection_module_default = /*#__PURE__*/__webpack_require__.n(CardsSection_module);
;// CONCATENATED MODULE: ./UI/sections/CaseCardsSection/utils/useCardsSection.js















var _obj;
var SLIDES_PER_VIEW = (_obj = {}, (0,_define_property/* default */.Z)(_obj, routes/* routes.bookCall.slug */._.bookCall.slug, {
    thirdSectionView: "auto",
    fourthSectionView: "auto"
}), (0,_define_property/* default */.Z)(_obj, constants/* CASE_STUDIES.kitchenEquipment */.qU.kitchenEquipment, {
    firstSectionView: "auto"
}), (0,_define_property/* default */.Z)(_obj, constants/* CASE_STUDIES.aiPoweredComplianceTool */.qU.aiPoweredComplianceTool, {
    firstSectionView: "auto"
}), _obj);
var _obj1;
var SPECIFIC_SETTINGS = (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, constants/* CASE_STUDIES.llmDocument */.qU.llmDocument, {
    breakpoints: {
        0: {
            slidesPerView: 1,
            slidesPerGroup: 1,
            centeredSlides: true
        },
        569: {
            slidesPerView: 1.3,
            slidesPerGroup: 1,
            centeredSlides: false
        },
        769: {
            slidesPerView: 1.7,
            slidesPerGroup: 1,
            centeredSlides: false
        },
        1025: {
            slidesPerView: 2.1,
            slidesPerGroup: 2,
            centeredSlides: false
        }
    }
}), (0,_define_property/* default */.Z)(_obj1, constants/* CASE_STUDIES.fintechAnalysis */.qU.fintechAnalysis, {
    breakpoints: {
        0: {
            slidesPerView: 1,
            slidesPerGroup: 1,
            centeredSlides: true
        },
        569: {
            slidesPerView: 1.8,
            slidesPerGroup: 1,
            centeredSlides: false
        },
        769: {
            slidesPerView: 2.6,
            slidesPerGroup: 2,
            centeredSlides: false
        },
        1025: {
            slidesPerView: 3.3,
            slidesPerGroup: 3,
            centeredSlides: false
        }
    }
}), (0,_define_property/* default */.Z)(_obj1, constants/* CASE_STUDIES.aiConcierge */.qU.aiConcierge, {
    breakpoints: {
        0: {
            slidesPerView: 1,
            slidesPerGroup: 1,
            centeredSlides: true
        },
        569: {
            slidesPerView: 1.8,
            slidesPerGroup: 1,
            centeredSlides: false
        },
        769: {
            slidesPerView: 2.6,
            slidesPerGroup: 2,
            centeredSlides: false
        },
        1025: {
            slidesPerView: 3.3,
            slidesPerGroup: 3,
            centeredSlides: false
        }
    }
}), (0,_define_property/* default */.Z)(_obj1, constants/* CASE_STUDIES.aiVoiceAssistant */.qU.aiVoiceAssistant, {
    breakpoints: {
        0: {
            slidesPerView: 1,
            slidesPerGroup: 1,
            centeredSlides: true
        },
        569: {
            slidesPerView: 1.8,
            slidesPerGroup: 1,
            centeredSlides: false
        },
        769: {
            slidesPerView: 2.6,
            slidesPerGroup: 2,
            centeredSlides: false
        },
        1025: {
            slidesPerView: 3.3,
            slidesPerGroup: 3,
            centeredSlides: false
        }
    }
}), (0,_define_property/* default */.Z)(_obj1, constants/* CASE_STUDIES.aiEdtech */.qU.aiEdtech, {
    breakpoints: {
        0: {
            slidesPerView: 1,
            slidesPerGroup: 1,
            centeredSlides: true
        },
        569: {
            slidesPerView: 1.9,
            slidesPerGroup: 1,
            centeredSlides: false
        },
        769: {
            slidesPerView: 2.7,
            slidesPerGroup: 1,
            centeredSlides: false
        },
        1025: {
            slidesPerView: 3.3,
            slidesPerGroup: 2,
            centeredSlides: false
        }
    }
}), (0,_define_property/* default */.Z)(_obj1, constants/* CASE_STUDIES.aiAssistantPatients */.qU.aiAssistantPatients, {
    breakpoints: {
        0: {
            slidesPerView: 1,
            slidesPerGroup: 1,
            centeredSlides: true
        },
        569: {
            slidesPerView: 1.8,
            slidesPerGroup: 1,
            centeredSlides: false
        },
        769: {
            slidesPerView: 2.6,
            slidesPerGroup: 2,
            centeredSlides: false
        },
        1025: {
            slidesPerView: 3.3,
            slidesPerGroup: 3,
            centeredSlides: false
        }
    }
}), (0,_define_property/* default */.Z)(_obj1, constants/* CASE_STUDIES.claudeSonnet */.qU.claudeSonnet, {
    breakpoints: {
        0: {
            slidesPerView: 1,
            slidesPerGroup: 1,
            centeredSlides: true
        },
        569: {
            slidesPerView: 1.8,
            slidesPerGroup: 1,
            centeredSlides: false
        },
        769: {
            slidesPerView: 2.6,
            slidesPerGroup: 2,
            centeredSlides: false
        },
        1025: {
            slidesPerView: 3.3,
            slidesPerGroup: 3,
            centeredSlides: false
        }
    }
}), _obj1);
var _obj2;
var SPACE_BETWEEN = (_obj2 = {}, (0,_define_property/* default */.Z)(_obj2, routes/* routes.bookCall.slug */._.bookCall.slug, {
    thirdSectionView: 66,
    fourthSectionView: 43
}), (0,_define_property/* default */.Z)(_obj2, constants/* CASE_STUDIES.digitalWallet */.qU.digitalWallet, {
    firstSectionView: 16
}), _obj2);
var REWIND = (0,_define_property/* default */.Z)({}, routes/* routes.bookCall.slug */._.bookCall.slug, {
    firstSectionView: true,
    secondSectionView: true,
    thirdSectionView: true
});
var cardMapper = function() {
    return function(card) {
        var ref, ref1, ref2;
        if ((card === null || card === void 0 ? void 0 : (ref = card.sys) === null || ref === void 0 ? void 0 : (ref1 = ref.contentType) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.sys) === null || ref2 === void 0 ? void 0 : ref2.id) === "article") {
            var ref3 = (0,helper/* getDocumentFields */.OA)(card, [
                "title",
                "previewImageUrl",
                "slug", 
            ]), title = ref3.title, previewImageUrl = ref3.previewImageUrl, slug = ref3.slug;
            var image = (0,helper/* getImage */.gJ)(previewImageUrl);
            return {
                url: "".concat(constants/* PAGES.blog */.q5.blog, "/").concat(slug),
                image: image,
                title: title,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "Read more"
                })
            };
        }
        var _ref = (0,helper/* getDocumentFields */.OA)(card, [
            "title",
            "contentList",
            "text",
            "images",
            "imagesBundles",
            "contentModules",
            "withOverlay", 
        ]), contentList = _ref.contentList, images = _ref.images, cardContent = _ref.contentModules, text = _ref.text, title1 = _ref.title, specificCardOverlay = _ref.withOverlay, rest = (0,_object_without_properties/* default */.Z)(_ref, [
            "contentList",
            "images",
            "contentModules",
            "text",
            "title",
            "withOverlay"
        ]);
        var image1 = (0,helper/* getImage */.gJ)(get_default()(images, "[0]"));
        var icon = get_default()(contentList, "[0]");
        var url = get_default()(cardContent, "[0].fields.url");
        var modules = (cardContent || []).filter(function(item) {
            var ref, ref1, ref2;
            return (item === null || item === void 0 ? void 0 : (ref = item.sys) === null || ref === void 0 ? void 0 : (ref1 = ref.contentType) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.sys) === null || ref2 === void 0 ? void 0 : ref2.id) !== "link";
        });
        var contentModules = specificCardOverlay ? modules : undefined;
        var items = specificCardOverlay ? undefined : modules.map(function(item) {
            return (0,helper/* getDocumentFields */.OA)(item, [
                "title",
                "contentList"
            ]);
        });
        var children = /*#__PURE__*/ (0,jsx_runtime.jsx)(Overlay/* default */.Z, {
            className: (CardsSection_module_default()).overlay,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card["default"], {
                title: title1,
                text: text
            })
        });
        return (0,_object_spread/* default */.Z)({
            url: url,
            image: image1,
            icon: icon,
            text: text,
            title: title1,
            children: children,
            items: items,
            contentModules: contentModules,
            specificCardOverlay: specificCardOverlay
        }, rest);
    };
};
/* harmony default export */ function useCardsSection(_param) {
    var section = _param.section, type = _param.type, sectionWithSlider = _param.withSlider, withOverlay = _param.withOverlay, data = _param.data, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "section",
        "type",
        "withSlider",
        "withOverlay",
        "data"
    ]);
    var ref, ref1, ref2, ref3, ref4;
    var ref5 = (0,helper/* getDocumentFields */.OA)(data || section, [
        "title",
        "description",
        "contentModules",
        "subtitle",
        "view",
        "images", 
    ], {
        isNormilized: data && !Object.keys(data).includes("fields") || section && !Object.keys(section).includes("fields")
    }), title = ref5.title, description = ref5.description, subtitle = ref5.subtitle, view = ref5.view, contentModules = ref5.contentModules, rawImages = ref5.images;
    var ref6 = (0,helper/* getDocumentFields */.OA)(get_default()(contentModules, "[0]", []), [
        "contentModules",
        "withoutBackground",
        "disableSliderOnMobile",
        "enableSliderOnDesktop",
        "enableSliderOnMobile", 
    ]), rawCardList = ref6.contentModules, withoutBackground = ref6.withoutBackground, disableSliderOnMobile = ref6.disableSliderOnMobile, enableSliderOnDesktop = ref6.enableSliderOnDesktop, enableSliderOnMobile = ref6.enableSliderOnMobile;
    var images = (rawImages || []).map(function(rawImage) {
        return (0,helper/* getImage */.gJ)(rawImage);
    });
    var cardList = (rawCardList || []).map(cardMapper(withOverlay));
    var ctaLink = get_default()(contentModules, "[1]");
    var isMobileResolution = (0,es.useSelector)(layout/* selectIsMobile */.eD);
    var isTabletResolution = (0,es.useSelector)(layout/* selectIsTablet */.aT);
    var IsFullResolution = (0,es.useSelector)(layout/* selectIsDesktop */.Y6);
    var withSlider = sectionWithSlider || enableSliderOnDesktop || !disableSliderOnMobile && (isTabletResolution || isMobileResolution) || enableSliderOnMobile && isMobileResolution;
    var isShowNavigation = enableSliderOnDesktop || !(IsFullResolution && (cardList === null || cardList === void 0 ? void 0 : cardList.length) <= 3);
    var swiperProps = (0,_object_spread/* default */.Z)({
        modules: [
            swiper_esm/* Navigation */.W_,
            swiper_esm/* Mousewheel */.Gk,
            swiper_esm/* Pagination */.tl
        ],
        slidesPerView: 3,
        // slidesPerGroup: 3,
        spaceBetween: ((ref = SPACE_BETWEEN[type]) === null || ref === void 0 ? void 0 : ref[view]) || 32,
        centeredSlides: false,
        autoHeight: false,
        passiveListeners: true,
        rewind: ((ref1 = REWIND[type]) === null || ref1 === void 0 ? void 0 : ref1[view]) || false,
        pagination: true,
        mousewheel: {
            forceToAxis: true
        },
        breakpoints: {
            0: {
                slidesPerView: ((ref2 = SLIDES_PER_VIEW[type]) === null || ref2 === void 0 ? void 0 : ref2[view]) || 1,
                slidesPerGroup: 1,
                centeredSlides: true
            },
            768: {
                slidesPerView: ((ref3 = SLIDES_PER_VIEW[type]) === null || ref3 === void 0 ? void 0 : ref3[view]) || 2,
                slidesPerGroup: 2,
                centeredSlides: false
            },
            1024: {
                slidesPerView: ((ref4 = SLIDES_PER_VIEW[type]) === null || ref4 === void 0 ? void 0 : ref4[view]) || 3,
                slidesPerGroup: 3,
                centeredSlides: false
            }
        }
    }, SPECIFIC_SETTINGS[type]);
    var className = classnames_default()((CardsSection_module_default()).cardsSection, (CardsSection_module_default())[type], (CardsSection_module_default())[view], (0,_define_property/* default */.Z)({}, (CardsSection_module_default()).withSlider, withSlider));
    return (0,_object_spread/* default */.Z)({
        type: type,
        view: view,
        withSlider: withSlider,
        cardList: cardList,
        ctaLink: ctaLink,
        title: title,
        description: description,
        subtitle: subtitle,
        className: className,
        withoutBackground: withoutBackground,
        swiperProps: swiperProps,
        withOverlay: withOverlay,
        isShowNavigation: isShowNavigation,
        images: images
    }, rest);
};

;// CONCATENATED MODULE: ./UI/sections/CaseCardsSection/index.jsx












var CaseCardsSection_Card = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 90704));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(90704)
            ];
        }
    }
});
var CallToAction = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 35767).then(__webpack_require__.bind(__webpack_require__, 49617));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(49617)
            ];
        }
    }
});
var Animated = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 61971).then(__webpack_require__.bind(__webpack_require__, 61971));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61971)
            ];
        }
    }
});
var CaseCardsSection_Illustration = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 93812));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(93812)
            ];
        }
    }
});
var CustomSwiper = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 33051));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(33051)
            ];
        }
    },
    ssr: false
});
var CardsSection = function(props) {
    var ref = useCardsSection(props), title = ref.title, subtitle = ref.subtitle, description = ref.description, cardList = ref.cardList, ctaLink = ref.ctaLink, withSlider = ref.withSlider, className = ref.className, handleOnCTAClick = ref.handleOnCTAClick, withoutBackground = ref.withoutBackground, withOverlay = ref.withOverlay, swiperProps = ref.swiperProps, isShowNavigation = ref.isShowNavigation, images = ref.images, backgroundImageUrl = ref.backgroundImageUrl;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: className,
        style: {
            backgroundImage: "url(".concat(backgroundImageUrl, ")")
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (CardsSection_module_default()).contentWrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle["default"], {
                    title: title,
                    subtitle: subtitle,
                    description: description,
                    className: (CardsSection_module_default()).title
                }),
                withSlider && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomSwiper, {
                    className: (CardsSection_module_default()).swiperList,
                    swiperParams: swiperProps,
                    isShowNavigation: isShowNavigation,
                    isShownPagination: true,
                    navigationClassName: (CardsSection_module_default()).navigation,
                    paginationClassName: (CardsSection_module_default()).pagination,
                    children: cardList.map(function(card, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CaseCardsSection_Card, (0,_object_spread/* default */.Z)({
                                className: classnames_default()((CardsSection_module_default()).card, (CardsSection_module_default())["card-".concat(i + 1)]),
                                withoutBackground: withoutBackground
                            }, card))
                        }, i);
                    })
                }),
                !withSlider && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (CardsSection_module_default()).cardList,
                    children: cardList.map(function(card, i) {
                        return /*#__PURE__*/ (0,react.createElement)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* REVEAL_ANIMATION_PROPS */.kt), {
                            delay: 50 * i,
                            key: "card/".concat(i)
                        }), /*#__PURE__*/ (0,jsx_runtime.jsx)(CaseCardsSection_Card, (0,_object_spread/* default */.Z)({
                            className: classnames_default()((CardsSection_module_default()).card, (CardsSection_module_default())["card-".concat(i + 1)], (0,_define_property/* default */.Z)({}, (CardsSection_module_default()).withOverlay, withOverlay)),
                            withoutBackground: withoutBackground
                        }, card), i));
                    })
                }),
                !!images.length && images.map(function(image) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CaseCardsSection_Illustration, {
                        src: image.url,
                        className: (CardsSection_module_default()).image
                    }, image.url);
                }),
                ctaLink && /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* REVEAL_ANIMATION_PROPS */.kt), {
                    transitionDelay: 50,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CallToAction, {
                        data: ctaLink,
                        handleOnClick: handleOnCTAClick,
                        className: (CardsSection_module_default()).callToAction
                    })
                }))
            ]
        })
    });
};
/* harmony default export */ var CaseCardsSection = (CardsSection);

;// CONCATENATED MODULE: ./UI/sections/TwoBlockChallanges/index.jsx










var TwoBlockChallanges = function(props) {
    var ref = useChallengesAndSolutionsWithWireframes(props), type = ref.type, view = ref.view, firstBlock = ref.firstBlock, secondBlock = ref.secondBlock, images = ref.images, backgroundImageUrl = ref.backgroundImageUrl;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: classnames_default()((styles_module_default())[type], (styles_module_default())[view], (styles_module_default()).container, {
        }),
        children: [
            !!images.length && images.map(function(image) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Illustration["default"], {
                    src: image.url,
                    className: (styles_module_default()).background
                });
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CaseCardsSection, {
                section: firstBlock,
                data: firstBlock,
                type: type,
                view: view,
                withSlider: true,
                backgroundImageUrl: backgroundImageUrl
            }),
            secondBlock && /*#__PURE__*/ (0,jsx_runtime.jsx)(ChallengesAndSolutions/* default */.Z, {
                data: secondBlock,
                type: type,
                view: view
            })
        ]
    });
};
TwoBlockChallanges.defaultProps = {
    type: ""
};
TwoBlockChallanges.propTypes = {
    data: prop_types_default().instanceOf(Object).isRequired,
    type: (prop_types_default()).string
};
/* harmony default export */ var sections_TwoBlockChallanges = (TwoBlockChallanges);


/***/ }),

/***/ 40659:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Common_LinkWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./utils/ga.js
var ga = __webpack_require__(48114);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
;// CONCATENATED MODULE: ./components/Common/LinkWrapper/helpers/index.js
var isAbsoluteUrl = function(path) {
    try {
        var _ = new URL(path);
        return true;
    } catch (e) {
        return false;
    }
};

// EXTERNAL MODULE: ./components/Common/LinkWrapper/styles.module.scss
var styles_module = __webpack_require__(81098);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./components/Common/LinkWrapper/index.jsx










var LinkWrapper = function(param) {
    var path = param.path, className = param.className, children = param.children, googleAnalyticProps = param.googleAnalyticProps, isSocialLink = param.isSocialLink, onClick = param.onClick;
    var isAbsoluteLink = (0,react.useMemo)(function() {
        return isAbsoluteUrl(path);
    }, [
        path
    ]);
    var isLocalLink = !isAbsoluteLink || path.includes(constants/* CUSTOM_DOMAIN */.zq);
    if (!path) {
        return children;
    }
    var target = !isLocalLink ? "_blank" : undefined;
    var rel = isSocialLink || isLocalLink ? undefined : "noopener noreferrer nofollow";
    var href = !isAbsoluteLink && path[0] !== "/" ? "/".concat(path) : path;
    var handleOnClick = function(e) {
        if (!isEmpty_default()(googleAnalyticProps)) {
            var category = googleAnalyticProps.category, action = googleAnalyticProps.action, label = googleAnalyticProps.label, data = googleAnalyticProps.data;
            ga/* default.trackEvent */.Z.trackEvent(category || data, action || data, label || data);
        }
        onClick(e);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: href,
        /* TODO: if you need to instantly open pages via links in the navigation,
      you can remove this code to enable link page generation and loading. However, performance will be degraded
      more: https://nextjs.org/docs/api-reference/next/link */ prefetch: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: classnames_default()((styles_module_default()).link, className),
            onClick: handleOnClick,
            target: target,
            rel: rel,
            children: children
        })
    });
};
LinkWrapper.defaultProps = {
    path: null,
    className: null,
    googleAnalyticProps: {},
    children: null,
    isSocialLink: false,
    onClick: function() {}
};
LinkWrapper.propTypes = {
    path: (prop_types_default()).string,
    className: (prop_types_default()).string,
    googleAnalyticProps: prop_types_default().instanceOf(Object),
    children: (prop_types_default()).node,
    isSocialLink: (prop_types_default()).bool,
    onClick: (prop_types_default()).func
};
/* harmony default export */ var Common_LinkWrapper = (LinkWrapper);


/***/ }),

/***/ 93856:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__msYo3","image":"Card_image__lDcsK","withoutBackground":"Card_withoutBackground__W7fGZ","title":"Card_title__3oNoL","withLink":"Card_withLink__QI1Gl","icon":"Card_icon__bKpvu","content":"Card_content__amq2q","cardContent":"Card_cardContent__g4BWE","itemList":"Card_itemList__3_kfl","item":"Card_item__hpzdo","itemIcon":"Card_itemIcon__3IkSz","contentModules":"Card_contentModules__yQFYp","nestedCard":"Card_nestedCard__gVsGc","overlapCard":"Card_overlapCard__fgfJv"};

/***/ }),

/***/ 42070:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"overlapCard":"OverlapCard_overlapCard__ZjLrZ","image":"OverlapCard_image__216M_","overlay":"OverlapCard_overlay__s_4Gv","badge":"OverlapCard_badge__QQrWF"};

/***/ }),

/***/ 14910:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"CardContainer_cardContainer__GnP7H","noBackground":"CardContainer_noBackground__jHEZf","sb_cardWithOverlay":"CardContainer_sb_cardWithOverlay__guDiR","overlay":"CardContainer_overlay__xSItN"};

/***/ }),

/***/ 44291:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Overlay_overlay__5DSjH"};

/***/ }),

/***/ 94211:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cardsWithFullWidthImage":"CardsSection_cardsWithFullWidthImage__z5qji","cards":"CardsSection_cards__V_cPl","imageWrapper":"CardsSection_imageWrapper__K2x0L","typeTitle":"CardsSection_typeTitle__DaZEx","greySection":"CardsSection_greySection__Zj7pb","callToAction":"CardsSection_callToAction__tWC8w","threeColumnsCards":"CardsSection_threeColumnsCards__zQ112","twoColumnsCards":"CardsSection_twoColumnsCards___I4Dl","cardList":"CardsSection_cardList__XPa3o","textContent":"CardsSection_textContent__MqSpl","cardWithFullSizeImage":"CardsSection_cardWithFullSizeImage___C6UR","blackSection":"CardsSection_blackSection__IzbeA","title":"CardsSection_title__7JCke","cardWithVerticalLine":"CardsSection_cardWithVerticalLine__iDwKl","cardsSection":"CardsSection_cardsSection__06OPP","overlay":"CardsSection_overlay__bYaKc","card":"CardsSection_card__QJ3_A","withOverlay":"CardsSection_withOverlay__pYHdG","contentWrapper":"CardsSection_contentWrapper__awk3R","cardWithTransperentBackground":"CardsSection_cardWithTransperentBackground__iYn7T","web-logistics-platform":"CardsSection_web-logistics-platform__Ls_F_","navigation":"CardsSection_navigation__RxZvZ","swiperList":"CardsSection_swiperList__AWOes","llm-legal-document-summarization":"CardsSection_llm-legal-document-summarization__sAsmi","image":"CardsSection_image__QqH2Q","ai-feedback-analysis":"CardsSection_ai-feedback-analysis__XTs5M","ai-for-edtech":"CardsSection_ai-for-edtech__pWbVD","ai-concierge-for-hotel-network":"CardsSection_ai-concierge-for-hotel-network__SKnsJ","ai-voice-assistant-for-e-learning":"CardsSection_ai-voice-assistant-for-e-learning__Py3VW","ai-assistant-for-chronic-patients":"CardsSection_ai-assistant-for-chronic-patients__S4QFk","claude-sonnet-leasing-operations-platform":"CardsSection_claude-sonnet-leasing-operations-platform__glXBP"};

/***/ }),

/***/ 89182:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__TsDfI","titleStyle":"styles_titleStyle__kd5qz","challengesWithoutImage":"styles_challengesWithoutImage__EWjvu","background":"styles_background__8opKM","web-logistics-platform":"styles_web-logistics-platform__xB2VL","llm-legal-document-summarization":"styles_llm-legal-document-summarization__dEmJk","ai-feedback-analysis":"styles_ai-feedback-analysis__Y_isa","ai-for-edtech":"styles_ai-for-edtech__I1cag","ai-concierge-for-hotel-network":"styles_ai-concierge-for-hotel-network__HzTaT","ai-voice-assistant-for-e-learning":"styles_ai-voice-assistant-for-e-learning__btvtV","ai-assistant-for-chronic-patients":"styles_ai-assistant-for-chronic-patients__vFoqN","claude-sonnet-leasing-operations-platform":"styles_claude-sonnet-leasing-operations-platform__jKxbl"};

/***/ }),

/***/ 81098:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"link":"styles_link__MXUD5"};

/***/ })

}]);